module.exports = __webpack_public_path__ + "img/Dantam Makeover 18.1d1cf15e.jpg";